import {
    registerComponents,
    registerConfigs,
    registerConstants,
    registerEnums,
    registerFactories,
    registerFilters,
    registerLayouts,
    registerProviders,
    registerResources,
    registerRuns,
    registerServices,
    registerStates
} from 'opus-angular-seed-core';
import './../../node_modules/ngprogress/build/ngProgress.js';
import './../../scripts/angular-signature/src/signature.js';
import { transformAndSanitizeResponse } from 'opus-angular-seed-core/src/globalHttpSanitization';

const Raven = require('raven-js');
Raven
    .config(SEED_CORE.ENV.SENTRY_DSN, {
        release: SEED_CORE.REVISION,
        ignoreErrors: [/^Non-Error exception/]
    })
    .addPlugin(require('raven-js/plugins/angular'), angular)
    .install();

const noop = () => {};
const logProxy = (method) => {
    if (SEED_CORE.ENV.NODE_ENV === 'development') {
        /* eslint no-console: "off" */
        return console[method].bind(console);
    }
    return noop;
};

const logger = {
    group: logProxy('group'),
    groupCollapsed: logProxy('group'),
    groupEnd: logProxy('groupEnd'),
    error: logProxy('error'),
    info: logProxy('info'),
    warn: logProxy('warn'),
    debug: logProxy('debug')
};

const { info, warn, debug, error } = logger;

const prefix = '';
const application = angular.module('app', [...SEED_CORE.DEPENDENCIES.ANGULAR, 'ngSanitize'])
    .config(['cfpLoadingBarProvider', '$httpProvider',
        function (cfpLoadingBarProvider, $httpProvider) {
            cfpLoadingBarProvider.includeSpinner = false;

            // COUR-9590 Fix for AngularJS Improper Input Validation Vulnerability
            $httpProvider.defaults.transformResponse.push(transformAndSanitizeResponse);
        }]);

const options = { application, prefix, info, warn, debug, error };

logger.groupCollapsed('[opus-angular-seed] Registration phase');

/*
 * Register directives
 */
// application.directive('tabs01', require('./directives/tabs01/index.js').default);
/**
 * Register configuration stuff
 */
registerConfigs(require.context('./configs', true, /index.js/), options);
registerLayouts(require.context('./layouts', true, /index.js/), options);
registerStates(require.context('./states', true, /index.js/), options);
registerConstants(require.context('./constants', true, /index.js/), options);
/**
 * Register application stuff
 */
registerComponents(require.context('./components', true, /index.js/), options);
registerResources(require.context('./resources', true, /index.js/), options);
registerFactories(require.context('./factories', true, /index.js/), options);
registerServices(require.context('./services', true, /index.js/), options);
registerFilters(require.context('./filters', true, /index.js/), options);
registerProviders(require.context('./providers', true, /index.js/), options);
registerEnums(require.context('./enums', true, /index.js/), options);

/**
 * Register run stuff
 */
registerRuns(require.context('./runs', true, /index.js/), options);

logger.groupEnd();
logger.group('[opus-angular-seed] Bootstrapping phase');

try {
    // angular.bootstrap(document, [application.name]);
    angular.bootstrap(document, [application.name].concat(SEED_CORE.DEPENDENCIES.ANGULAR));
}
catch (e) {
    warn('Creating angular application failed. Check your dependencies and vendors');
    info(`Angular module name: ${application.name}`);
    info(`Angular dependencies (package.json field 'angularDependencies'): ${SEED_CORE.DEPENDENCIES.ANGULAR}`);
    info(`Vendors (package.json field 'vendors'): ${SEED_CORE.VENDORS}`);
    throw e;
}
logger.groupEnd();



// WEBPACK FOOTER //
// ./src/app/bootstrap.js